<div class="ms-eq">

  <div class="ms-eq__header">
    <label class="ms-eq__toggle">
      <p-inputSwitch [ngModel]="eqEnabled" (ngModelChange)="toggleEq()" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
      Stems Eq
    </label>
    <select class="ms-eq__preset" [value]="selectedPreset"
      (change)="applyPreset($any($event.target).value)" [disabled]="!eqEnabled">
      <option *ngFor="let p of presetNames" [value]="p">{{ p }}</option>
    </select>
  </div>

  <div class="ms-eq__axis-labels">
    <span>Boost</span>
    <span>0 dB</span>
    <span>Mute</span>
  </div>

  <div class="ms-eq__sliders" [class.ms-eq__sliders--disabled]="!eqEnabled">
    <div *ngFor="let id of stemIds" class="ms-eq__stem">
      <div class="ms-eq__fader-wrap">
        <div class="ms-eq__track">
          <div class="ms-eq__fill" [style]="horizontal ? getHFillStyle(id) : getFillStyle(id)"></div>
        </div>
        <input
          type="range"
          class="ms-eq__range"
          [min]="eqMin" [max]="eqMax" step="1"
          [value]="getLevel(id)"
          [disabled]="!eqEnabled"
          (input)="onSliderChange(id, $any($event.target).value)"
          (wheel)="onWheel(id, $event)" />
      </div>
      <span class="ms-eq__val"
        [class.ms-eq__val--boost]="getLevel(id) > 0"
        [class.ms-eq__val--muted]="getLevel(id) <= eqMin">
        {{ formatVal(getLevel(id)) }}
      </span>
      <span class="ms-eq__icon"><i class="pi pi-sliders-h"></i></span>
      <span class="ms-eq__label">{{ id | titlecase }}</span>
    </div>
  </div>

  <div class="ms-eq__footer">
    <span class="ms-eq__hint">Drag knobs · scroll to fine-tune</span>
    <button class="ms-eq__reset" (click)="reset()">
      <i class="pi pi-refresh"></i> Reset
    </button>
  </div>

</div>
